import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollHandler from "./components/ScrollHandler";
import NotFound from "./screens/NotFound";
import Inicio from "./screens/inicio";
import Tos from "./screens/tos";
import Pov from "./screens/pov";

function App() {
  return (
    <div>
      <Router>
        {/* ScrollHandler debe estar DENTRO de Router */}
        <ScrollHandler />
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/inicio" element={<Inicio />} />
          <Route path="/tos" element={<Tos />} />
          <Route path="/privacidad" element={<Pov />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
